module.exports = __webpack_public_path__ + "img/q80_2.29448855.png";